[
  {
    "id": 88,
    "documentId": "i8u43sscfmvd628cub4vlvvl",
    "title": "Salingsapa - Sign Language Recognition App",
    "slug": "salingsapa",
    "description": "A video call app to enable deaf people to communicate with normal people using Sign Language Recognition (SLR) and Speech-to-Text (STT). This innovative solution bridges communication gaps between deaf and hearing individuals.",
    "summary": "Video call app with sign language recognition for deaf communication",
    "type": "personal",
    "currentStatus": "in-progress",
    "startDate": "2023-01-01",
    "endDate": "2023-06-30",
    "achievements": "Successfully launched on both App Store and Play Store. Implemented real-time sign language recognition and speech-to-text functionality.",
    "challenges": "Complex real-time video processing and sign language recognition implementation. Ensuring accessibility compliance for deaf users.",
    "learnings": "Advanced computer vision techniques, accessibility design principles, and real-time video processing optimization.",
    "role": "Lead Developer",
    "teamSize": 3,
    "client": null,
    "isFeatured": true,
    "isPublic": true,
    "createdAt": "2025-08-05T12:23:58.709Z",
    "updatedAt": "2025-08-05T12:23:58.709Z",
    "publishedAt": "2025-08-05T12:23:58.714Z",
    "skills": [],
    "coverImage": null,
    "gallery": [],
    "links": [
      {
        "id": 386,
        "label": "App Store",
        "url": "https://apps.apple.com/app/salingsapa/id6447261524",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "iOS version",
        "isVisible": null
      },
      {
        "id": 387,
        "label": "Play Store",
        "url": "https://play.google.com/store/apps/details?id=dev.baharudin.salingsapa",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Android version",
        "isVisible": null
      },
      {
        "id": 388,
        "label": "GitHub",
        "url": "https://github.com/baharudin-yusup/salingsapa",
        "type": "github",
        "showIcon": true,
        "isExternal": true,
        "description": "Source code",
        "isVisible": null
      }
    ],
    "experiences": [],
    "seo": null
  },
  {
    "id": 90,
    "documentId": "l1xrwkfhrgb892jrxd4xkf8x",
    "title": "TMDB Catalog - Android Movie App",
    "slug": "tmdb-catalog",
    "description": "A Kotlin-based Android app that utilizes TMDb API. Built with Clean Architecture combined with Modular Software Architecture, the app integrates GitHub Actions CI/CD.",
    "summary": "Android movie catalog app with clean architecture",
    "type": "personal",
    "currentStatus": "in-progress",
    "startDate": "2022-01-01",
    "endDate": "2022-06-30",
    "achievements": "Successfully published on Play Store. Implemented clean architecture with modular design. Integrated CI/CD pipeline with GitHub Actions.",
    "challenges": "Implementing clean architecture patterns in Android. Setting up modular architecture for scalability.",
    "learnings": "Android clean architecture, modular design patterns, CI/CD implementation, and TMDb API integration.",
    "role": "Solo Developer",
    "teamSize": 1,
    "client": null,
    "isFeatured": true,
    "isPublic": true,
    "createdAt": "2025-08-05T12:23:58.730Z",
    "updatedAt": "2025-08-05T12:23:58.730Z",
    "publishedAt": "2025-08-05T12:23:58.733Z",
    "skills": [],
    "coverImage": null,
    "gallery": [],
    "links": [
      {
        "id": 391,
        "label": "Play Store",
        "url": "https://play.google.com/store/apps/details?id=dev.baharudin.tmdb_android",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Android version",
        "isVisible": null
      },
      {
        "id": 392,
        "label": "GitHub",
        "url": "https://github.com/baharudin-yusup/tmdb-android",
        "type": "github",
        "showIcon": true,
        "isExternal": true,
        "description": "Source code",
        "isVisible": null
      }
    ],
    "experiences": [],
    "seo": null
  },
  {
    "id": 92,
    "documentId": "smoun71682md1gonn2giwaf0",
    "title": "Weather Info - Kotlin Weather App",
    "slug": "weather-info",
    "description": "A Kotlin-based app that provides real-time weather data and 4-day forecasts for multiple cities, with a user-friendly interface and Clean Architecture.",
    "summary": "Weather app with real-time data and forecasts",
    "type": "personal",
    "currentStatus": "in-progress",
    "startDate": "2021-06-01",
    "endDate": "2021-12-31",
    "achievements": "Successfully published on Play Store. Implemented clean architecture and real-time weather data integration.",
    "challenges": "Integrating with weather APIs and implementing clean architecture patterns.",
    "learnings": "Weather API integration, Kotlin development, clean architecture implementation, and user interface design.",
    "role": "Solo Developer",
    "teamSize": 1,
    "client": null,
    "isFeatured": false,
    "isPublic": true,
    "createdAt": "2025-08-05T12:23:58.751Z",
    "updatedAt": "2025-08-05T12:23:58.751Z",
    "publishedAt": "2025-08-05T12:23:58.754Z",
    "skills": [],
    "coverImage": null,
    "gallery": [],
    "links": [
      {
        "id": 394,
        "label": "GitHub",
        "url": "https://github.com/baharudin-yusup/weather-info",
        "type": "github",
        "showIcon": true,
        "isExternal": true,
        "description": "Source code",
        "isVisible": null
      }
    ],
    "experiences": [],
    "seo": null
  },
  {
    "id": 94,
    "documentId": "dfu22s0cnr56h5btca6aisrn",
    "title": "Lakone Smart Coffee Roaster - IoT & Mobile App",
    "slug": "smart-coffee-roaster",
    "description": "Built the Lakone smart coffee roaster: a Flutter app that controls and monitors the roaster over Bluetooth Low Energy, paired with embedded C++ firmware running on the device.",
    "summary": "IoT coffee roaster with mobile control and monitoring",
    "type": "work",
    "currentStatus": "completed",
    "startDate": "2020-05-01",
    "endDate": "2021-06-30",
    "achievements": "Built a Flutter app that controls and monitors smart coffee roasters over Bluetooth Low Energy, adopted by roasters across Indonesia. Implemented a PID-style control loop in the embedded C++ firmware that keeps the roaster on target temperature curves, making roast profiles repeatable.",
    "challenges": "Keeping the roaster on target temperature curves over a Bluetooth Low Energy link, and making roast profiles repeatable across sessions.",
    "learnings": "IoT device development, cross-platform mobile development, real-time communication protocols, temperature control systems, and hardware-software integration.",
    "role": "Lead Developer & IoT Engineer",
    "teamSize": 3,
    "client": null,
    "isFeatured": true,
    "isPublic": true,
    "createdAt": "2025-08-05T12:23:58.771Z",
    "updatedAt": "2026-08-14T09:16:19.797Z",
    "publishedAt": "2026-08-14T09:16:19.814Z",
    "skills": [],
    "coverImage": null,
    "gallery": [],
    "links": [],
    "experiences": [],
    "seo": null
  },
  {
    "id": 95,
    "documentId": "r652mrf9bi8juh4v35d1nnev",
    "title": "Avis Budget Group Mobile App Rewrite",
    "slug": "avis-budget-group-mobile-app",
    "description": "Led the consolidation and rewrite of the Avis Budget Group global car rental suite: 8 apps (Avis and Budget, each on Android and iOS across NAM/APAC and EMEA), built natively and in Flutter, into one React Native codebase serving 15M+ users.",
    "summary": "8 apps consolidated into one React Native codebase for 15M+ users",
    "type": "work",
    "currentStatus": "completed",
    "startDate": "2023-11-01",
    "endDate": "2024-06-30",
    "achievements": "Consolidated 8 native and Flutter apps into a single React Native codebase. Delivered 18% faster app launch, 45% fewer crashes, and 60%+ higher code reuse. Served 15M+ users across NAM/APAC and EMEA.",
    "challenges": "Migrating 8 apps from native and Flutter stacks onto one React Native codebase. Letting each region customize its apps without forking that codebase. Coordinating a cross-region engineering team.",
    "learnings": "Large-scale mobile app consolidation, cross-platform development strategies, team leadership in complex projects, and performance optimization for enterprise applications.",
    "role": "Technical Lead",
    "teamSize": 8,
    "client": "Avis Budget Group",
    "isFeatured": true,
    "isPublic": true,
    "createdAt": "2025-08-05T12:23:58.582Z",
    "updatedAt": "2026-08-14T09:16:46.425Z",
    "publishedAt": "2026-08-14T09:16:46.436Z",
    "skills": [],
    "coverImage": null,
    "gallery": [],
    "links": [
      {
        "id": 395,
        "label": "Avis NAM App",
        "url": "https://apps.apple.com/us/app/avis-car-rental/id308342527",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "North America app",
        "isVisible": true
      },
      {
        "id": 396,
        "label": "Avis APAC App",
        "url": "https://play.google.com/store/apps/details?id=com.avis.androidapp",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Asia-Pacific app",
        "isVisible": true
      },
      {
        "id": 397,
        "label": "Avis EMEA App",
        "url": "https://apps.apple.com/gb/app/avis-car-hire/id883735332",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Europe, Middle East, Africa app",
        "isVisible": true
      }
    ],
    "experiences": [],
    "seo": null
  },
  {
    "id": 96,
    "documentId": "vnlp60hryap4p8twf5lggbm0",
    "title": "StyleUp - UOB Bank Clothing Ordering App",
    "slug": "styleup-uob-bank-clothing-app",
    "description": "Developed StyleUp!, a clothing ordering app for United Overseas Bank employees, streamlining uniform ordering across Southeast Asia.",
    "summary": "Mobile app for UOB bank employee clothing orders",
    "type": "work",
    "currentStatus": "completed",
    "startDate": "2023-01-01",
    "endDate": "2023-06-30",
    "achievements": "Developed and launched the Flutter app on Clean Architecture with BLoC state management, streamlining uniform ordering for 5,000+ bank employees across Southeast Asia. Integrated Firebase for real-time order tracking and push notifications, cutting order errors by 25%.",
    "challenges": "Integrating with bank's existing systems and ensuring security compliance. Managing inventory synchronization and order tracking.",
    "learnings": "Banking system integration, security compliance, inventory management, and enterprise mobile app development.",
    "role": "Mobile Developer",
    "teamSize": 4,
    "client": "UOB Bank",
    "isFeatured": true,
    "isPublic": true,
    "createdAt": "2025-08-05T12:23:58.644Z",
    "updatedAt": "2026-08-14T09:16:46.675Z",
    "publishedAt": "2026-08-14T09:16:46.687Z",
    "skills": [],
    "coverImage": null,
    "gallery": [],
    "links": [
      {
        "id": 398,
        "label": "Style Up Android",
        "url": "https://play.google.com/store/apps/details?id=com.styleup.app",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "UOB clothing app for Android",
        "isVisible": true
      },
      {
        "id": 399,
        "label": "Style Up iOS",
        "url": "https://apps.apple.com/id/app/style-up/",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "UOB clothing app for iOS",
        "isVisible": true
      }
    ],
    "experiences": [],
    "seo": null
  },
  {
    "id": 97,
    "documentId": "czkiouvz2i2zrjv5gigoke25",
    "title": "vOCC - Scoot Airline Virtual Operation Control Center",
    "slug": "vocc-scoot-airline-control-center",
    "description": "Developed the Virtual Operation Control Center (vOCC), a mission-critical flight-operations Android app for Scoot Airline, with role-based workflows for pilots, ground staff, and ops managers.",
    "summary": "Flight-operations Android app for Scoot Airline",
    "type": "work",
    "currentStatus": "completed",
    "startDate": "2022-12-01",
    "endDate": "2023-03-31",
    "achievements": "Built on the classic Android stack (Kotlin, Fragments, XML views) with role-based workflows for pilots, ground staff, and ops managers. Maintained a 99.8% crash-free session rate in production for daily flight operations.",
    "challenges": "Ensuring high availability and reliability for critical airline operations. Implementing real-time data synchronization and monitoring.",
    "learnings": "Critical system development, real-time monitoring, airline operations, and high-availability mobile applications.",
    "role": "Mobile Developer",
    "teamSize": 3,
    "client": "Scoot Airline",
    "isFeatured": false,
    "isPublic": true,
    "createdAt": "2025-08-05T12:23:58.667Z",
    "updatedAt": "2026-08-14T09:16:46.924Z",
    "publishedAt": "2026-08-14T09:16:46.936Z",
    "skills": [],
    "coverImage": null,
    "gallery": [],
    "links": [
      {
        "id": 400,
        "label": "Scoot Airlines",
        "url": "https://www.flyscoot.com",
        "type": "website",
        "showIcon": true,
        "isExternal": true,
        "description": "Scoot Airlines official website",
        "isVisible": true
      }
    ],
    "experiences": [],
    "seo": null
  },
  {
    "id": 98,
    "documentId": "j40diyoq82j0vh8k672qddoj",
    "title": "BRI Ceria - Personal Loan App",
    "slug": "bri-ceria-personal-loan-app",
    "description": "Developed Ceria, a personal loan app with 5M+ downloads for Indonesia's largest state-owned bank, migrating the legacy Java app to Flutter.",
    "summary": "Personal loan app for Bank Rakyat Indonesia",
    "type": "work",
    "currentStatus": "completed",
    "startDate": "2022-07-01",
    "endDate": "2023-04-30",
    "achievements": "Migrated the legacy Java app to a modern Flutter codebase, accelerating new-feature delivery by 40%. Designed a simple custom architecture with Provider state management that the bank's in-house team could easily maintain and extend. Removed redundant API and Firebase calls, saving ~IDR 3B per month in infrastructure costs.",
    "challenges": "Large-scale app migration from Java to Flutter. Maintaining backward compatibility and ensuring smooth transition for existing users.",
    "learnings": "Large-scale app migration, performance optimization, cost reduction strategies, and banking app development.",
    "role": "Mobile Developer",
    "teamSize": 6,
    "client": "PT Bank Rakyat Indonesia (Persero) Tbk",
    "isFeatured": true,
    "isPublic": true,
    "createdAt": "2025-08-05T12:23:58.688Z",
    "updatedAt": "2026-08-14T09:16:47.177Z",
    "publishedAt": "2026-08-14T09:16:47.186Z",
    "skills": [],
    "coverImage": null,
    "gallery": [],
    "links": [
      {
        "id": 401,
        "label": "BRI Ceria Android",
        "url": "https://play.google.com/store/apps/details?id=id.co.bri.ceria",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Personal loan app for Android",
        "isVisible": true
      },
      {
        "id": 402,
        "label": "BRI Ceria iOS",
        "url": "https://apps.apple.com/id/app/bri-ceria/id1670051543",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Personal loan app for iOS",
        "isVisible": true
      }
    ],
    "experiences": [],
    "seo": null
  }
]
